import type { ComponentPropsWithRef, ReactNode } from 'react';
import { Navigation, Virtual } from 'swiper/modules';

import { BreakpointsValues } from '@zoomit/primitives';
import { SwiperBase } from '@zoomit/web-kit';

type BreakPoints = {
  slidesPerView: number | 'auto';
  spaceBetween: number;
};

type Props = {
  slides: ReactNode[];
  slidesPerView?: number | 'auto';
  breakpoints?: {
    xl?: BreakPoints;
    md?: BreakPoints;
  };
} & ComponentPropsWithRef<typeof SwiperBase>;

const DesktopModuleSwiper = (props: Props) => {
  const { slides, breakpoints, slidesPerView = 1, ...rest } = props;

  const swiperBreakpoints = {
    [`${BreakpointsValues.xl}`]: {
      slidesPerView: breakpoints?.xl?.slidesPerView ?? 4,
      spaceBetween: breakpoints?.xl?.spaceBetween ?? 25,
    },
    [`${BreakpointsValues.md}`]: {
      slidesPerView: breakpoints?.md?.slidesPerView ?? 3,
      spaceBetween: breakpoints?.md?.spaceBetween ?? 30,
    },
  };

  return (
    <SwiperBase
      spaceBetween={10}
      slidesPerView={slidesPerView}
      grabCursor={true}
      navigation={{
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
      }}
      modules={[Navigation, Virtual]}
      breakpoints={swiperBreakpoints}
      slides={slides}
      hasNextArrow={true}
      hasPrevArrow={true}
      {...rest}
    />
  );
};

export default DesktopModuleSwiper;
